import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "order-1 grid grid-cols-2 text-xl text-center font-medium border-b border-gray-400" }
const _hoisted_3 = { class: "py-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Forløb startet", -1)
const _hoisted_5 = { class: "text-2xl font-semibold leading-10" }
const _hoisted_6 = { class: "py-6 border-l border-gray-400" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "Forløb afsluttet", -1)
const _hoisted_8 = { class: "text-2xl font-semibold leading-10" }
const _hoisted_9 = { class: "screen:order-2 print:order-3 grid screen:grid-cols-2 print:grid-cols-1" }
const _hoisted_10 = { class: "screen:order-3 print:order-2 grid" }
const _hoisted_11 = {
  key: 0,
  class: "screen:border-b border-gray-400 screen:w-full print:mx-auto"
}
const _hoisted_12 = { class: "order-4" }
const _hoisted_13 = {
  key: 0,
  class: "screen:border-b border-gray-400 screen:w-full print:mx-auto"
}
const _hoisted_14 = { class: "order-5" }
const _hoisted_15 = {
  key: 0,
  class: "screen:border-b border-gray-400 screen:w-full print:mx-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericChart = _resolveComponent("GenericChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.courseStatistics.length), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("h2", _hoisted_8, _toDisplayString(`${_ctx.endedCourseStatistics.length} ${isNaN(_ctx.percentageOfCourseStatisticsHasEnded) ? '' : `(${_ctx.percentageOfCourseStatisticsHasEnded})%`}`), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.charts, (chart) => {
        return (_openBlock(), _createElementBlock("div", {
          key: chart.id,
          class: _normalizeClass([{ 'bg-gray-100': chart.group % 2 === 0 }, "screen:border-b print:border-b-2 screen:even:border-l border-gray-400 print:mx-auto"])
        }, [
          _createVNode(_component_GenericChart, {
            "print-title": chart.printTitle || '',
            class: "print:mx-auto",
            options: chart.options
          }, null, 8, ["print-title", "options"])
        ], 2))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.regionsColumnChart)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_GenericChart, {
              "print-title": _ctx.regionsColumnChart.printTitle,
              options: _ctx.regionsColumnChart.options
            }, null, 8, ["print-title", "options"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_ctx.accumulatedDevelopmentChart)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_GenericChart, {
              "print-title": _ctx.accumulatedDevelopmentChart.printTitle,
              options: _ctx.accumulatedDevelopmentChart.options
            }, null, 8, ["print-title", "options"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      (_ctx.developmentChart)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(_component_GenericChart, {
              "print-title": _ctx.developmentChart.printTitle,
              options: _ctx.developmentChart.options
            }, null, 8, ["print-title", "options"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}